<app-datatable
  tableId="exam-report-table"
  [dataSourceUrl]="this.dtDataSourceUrl"
  [settings]="this.dtSettings"
  [events]="this.dtEvents"
  (onInit)="this.onInit($event)"
  (onAction)="this.onAction($event)"
>
  <th class="column-hide" data-data="id">Id</th>
  <th data-data="identifier">Azonosító</th>
  <th class="datetime" data-data="openedAtUtc">Nyitás időpontja</th>
  <th class="datetime" data-data="closedAtUtc">Zárás időpontja</th>
  <th class="datetime" data-data="examStartedAtUtc">Vizsga kezdete</th>
  <th class="datetime" data-data="examEndedAtUtc">Vizsga vége</th>
  <th data-data="studentsCount">Vizsgázók száma</th>
  <th data-data="examinersCount">Vizsgabiztosok száma</th>
  <th data-data="examAddress" class="long-text-50">Vizsga helyszíne</th>
  <th class="datetime" data-data="lastSendAtUtc">Utolsó beküldés időpontja</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>
